import { StoreFragmentType } from './types';

const storeFragment: StoreFragmentType = {};

export const registerStoreFragments = <T>(fragments: any): T => {
    Object.assign(storeFragment, fragments);
    return storeFragment as T;
};

export const getFragment = (name: string) => storeFragment[name];
